import Delete from '@mui/icons-material/DeleteOutlineRounded';
import { useNewBlockDeletedHandler } from '../../hooks/useNewBlockDeletedHandler.ts';
import { useSectionData } from '../../Sections/useSectionContext';
import '../GridDndEditor.less';
import BlockSettingsToolButton from './BlockSettingsToolButton';
import { useBlockLockStatus } from '../../hooks/useBlockLockStatus';
import { useSignaturesContext } from '../../providers/SignaturesProvider';
import { GridBlockType } from 'services/entities/BlockTypes';

export interface DeleteToolProp {
  blockId: string;
}
export default function DeleteTool({ blockId }: DeleteToolProp) {
  const gridBlockDeletedHandler = useNewBlockDeletedHandler();
  const { blocksContent, sectionId } = useSectionData();
  const { isLocked } = useBlockLockStatus(blockId);
  const { handleSignatureRemoval } = useSignaturesContext();

  const handleDeleteOk = () => {
    const blockContent = blocksContent[blockId];
    if (blockContent.type === GridBlockType.SIGNATURE) {
      handleSignatureRemoval({ sectionId, signatureId: blockId }, blocksContent);
    } else {
      gridBlockDeletedHandler(sectionId, blockId);
    }
  };

  if (isLocked) {
    return null;
  }

  return (
    <BlockSettingsToolButton title="Delete block" onClick={() => handleDeleteOk()} data-testid="grid-delete-component">
      <Delete width={24} height={24} fontSize="small" color="inherit" />
    </BlockSettingsToolButton>
  );
}
